import React, { Component } from "react";
import ReactRoundedImage from "react-rounded-image";
import logo from "../../assets/img/brand/wizmen.png";
import { Col, Row } from "reactstrap";
import { baseurl } from "../../baseurl.js";
import { Redirect } from "react-router-dom";
import axios from "axios";
import moment from "moment";
// import ReactToPrint from "react-to-print";
// import { jsPDF } from "jspdf";

var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companyId = localStorage.getItem("companyId");

/////////////////////////////-------------------ClassComponents Start Here----------///////////////////////////
class PrintViewCN extends Component {
  constructor(props) {
    super(props);

    let tempLogedIn = false;
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }
    let propInvoiceId = this.props.location.state?.propInvoiceId;
    propInvoiceId = propInvoiceId ? propInvoiceId : -1;
    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      logInStatus: tempLogedIn,
      invoiceNo: "",
      poNumber: "",
      issueDate: "",
      dueDate: "",
      company_Name: "",
      client_Name: "",
      dis_total_items: -1,
      sub_Amount_total_items: -1,
      total_Amount: -1,
      invoiceId: propInvoiceId,
    };
    thisContex = this;
  }

  componentDidMount() {
    this.getPrintCall();
  }

  getPrintCall() {
    // let invoiceId = 7;
    if (this.state.invoiceId !== -1) {
      axios
        .post(
          `${baseurl}/masterData/getPrintInvoiceView`,
          {
            username: username,
            invoiceId: this.state.invoiceId,
            companyId: companyId,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          let res_mt = response.data.data[0];
          let res_det = response.data.data1;
          let dis_total_items = 0;
          let sub_Amount_total_items = 0;
          let total_Amount = 0;

          let invoiceNo = res_mt["DOCUMENT_NO"];
          let poNumber = res_mt["INVOICE_REF_NO"];
          let issueDate = res_mt["INVOICE_DATE"];
          let dueDate = res_mt["DUE_DATE"];
          let company_Name = res_mt["Company_Name"];
          let client_Name = res_mt["Client_Name"];
          let saleTaxAmount = res_det[0]["staxAmount"];
          let salesTax = res_det[0]["salesTax"];

          let Address = res_mt["Address"];
          let email = res_mt["email"];
          let phone = res_mt["phone"];
          let company_no = res_mt["company_no"];
          let CURRENCY_DESC = res_mt["CURRENCY_DESC"];
          for (let index = 0; index < res_det.length; index++) {
            dis_total_items += res_det[index].TC_DISCOUNT;
            sub_Amount_total_items += res_det[index].TC_AMOUNT;
          }

          sub_Amount_total_items = sub_Amount_total_items - dis_total_items;
          total_Amount = res_det[0]["AMOUNT"];

          thisContex.setState({
            invoiceNo: invoiceNo,
            poNumber: poNumber,
            issueDate: moment(issueDate).format("DD MMMM YYYY"),
            dueDate: moment(dueDate).format("DD MMMM YYYY"),
            company_Name: company_Name,
            client_Name: client_Name,
            res_det: res_det,
            dis_total_items: dis_total_items,
            sub_Amount_total_items: sub_Amount_total_items,
            total_Amount: total_Amount,
            saleTaxAmount,
            salesTax,
            CURRENCY_DESC,
            phone,
            email,
            company_no,
            Address,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  render() {
    const {
      invoiceId,
      logInStatus,
      invoiceNo,
      poNumber,
      issueDate,
      dueDate,
      company_Name,
      client_Name,
      dis_total_items,
      sub_Amount_total_items,
      total_Amount,
      saleTaxAmount,
      salesTax,
      phone,
      email,
      company_no,
      Address,
      CURRENCY_DESC,
    } = this.state;
    if (logInStatus === false) {
      return <Redirect to="/login" />;
    } else if (invoiceId !== -1) {
      return (
        <div>
          <div style={{ textAlign: "end" }}>
            <button
              className="btn btn-primary"
              id="printPageButton"
              onClick={() => {
                window.print();
              }}
            >
              Print to PDF!
            </button>
          </div>

          <Row className="app-body-Invoice">
            <Col>
              <div
                className="col-md-12"
                style={{ width: "1100px", margin: "0 auto" }}
              >
                <div className="col-md-9">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 style={{ fontWeight: "bold" }}>
                        Credit Note {invoiceNo}
                      </h2>
                    </div>
                    {poNumber !== "undefined" ? (
                      <div className="col-md-6">
                        <h3>PO Number: {poNumber}</h3>
                      </div>
                    ) : null}
                  </div>
                </div>

                <hr
                  style={{
                    border: "1px solid Light gray",
                  }}
                />
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-7">
                      <ReactRoundedImage
                        image={logo}
                        roundedColor="#321124"
                        imageWidth="115"
                        imageHeight="115"
                        roundedSize="4"
                      />
                    </div>
                    <div className="col-md-5">
                      <h4
                        style={{
                          textAlign: "right",
                        }}
                      >
                        Issue Date : {issueDate}
                      </h4>
                      {poNumber !== "undefined" ? (
                        <h4 style={{ fontWeight: "bold", textAlign: "right" }}>
                          Due Date : {dueDate}
                        </h4>
                      ) : null}
                    </div>
                  </div>
                </div>
                <hr
                  style={{
                    border: "1px solid Light gray",
                  }}
                />
                <div className="col-md-12">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-8">
                        <h1>{company_Name}</h1>
                      </div>
                      <div className="col-md-4">
                        <h2
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {client_Name}
                        </h2>
                        <h3> Address: {Address}&emsp;&emsp;</h3>
                        <h3
                          style={{
                            color: "slategray",
                          }}
                        >
                          Phone: {phone}&emsp;
                        </h3>
                        <h3> Mail: {email}</h3>
                        <h3> Reg #: {company_no}</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <hr
                  style={{
                    border: "1px solid Light gray",
                  }}
                />
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12">
                      <table>
                        <tr>
                          <th>Qty</th>
                          <th>Unit</th>
                          <th>Description</th>
                          <th> </th>
                          <th> </th>
                          <th> </th>
                          <th> </th>
                          <th>Rate</th>
                          <th>Amount</th>
                        </tr>

                        {this.state.res_det?.map((itm, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <td>{itm.Item_Desc_Lov}</td>
                                <td>{itm.PRIMARY_QTY.toString()}</td>
                                <td>{itm.ITEM_DESC}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  {CURRENCY_DESC}{" "}
                                  {(itm.TC_AMOUNT / itm.PRIMARY_QTY)
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                <td>
                                  {CURRENCY_DESC}{" "}
                                  {itm.TC_AMOUNT.toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </table>
                    </div>
                    <div className="col-md-8"></div>
                    <div className="col-md-4">
                      <h3
                        style={{
                          color: "slategray",
                          textAlign: "right",
                        }}
                      >
                        Discount: {CURRENCY_DESC} -
                        {dis_total_items
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </h3>
                    </div>
                    <div className="col-md-12">
                      <hr
                        style={{
                          border: "1px solid Light gray",
                        }}
                      />
                    </div>

                    <div className="col-md-8"></div>
                    <div className="col-md-4">
                      <h3 style={{ textAlign: "right" }}>
                        Subtotal : {CURRENCY_DESC}{" "}
                        {sub_Amount_total_items
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </h3>
                      <hr
                        style={{
                          border: "1px solid Light gray",
                        }}
                      />
                    </div>
                    <div className="col-md-8"></div>
                    {saleTaxAmount ? (
                      <div className="col-md-4">
                        <h3 style={{ textAlign: "right" }}>
                          Sale Tax ({salesTax}%): {CURRENCY_DESC}{" "}
                          {saleTaxAmount
                            ?.toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </h3>
                        <hr
                          style={{
                            border: "1px solid Light gray",
                          }}
                        />
                      </div>
                    ) : null}
                    <div className="col-md-8"></div>
                    <div className="col-md-2">
                      <h3
                        style={{
                          color: "#00AA36",
                          fontWeight: "bold",
                        }}
                      >
                        TOTAL:
                      </h3>
                    </div>
                    <div className="col-md-2">
                      <h3
                        style={{
                          color: "#00AA36",
                          fontWeight: "bold",
                          textAlign: "right",
                        }}
                      >
                        {CURRENCY_DESC}{" "}
                        {total_Amount
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </h3>
                    </div>

                    <br></br>
                    <br></br>
                    <br></br>
                    <hr
                      style={{
                        border: "1px solid Light gray",
                      }}
                    />
                    <div className="col-md-10">
                      <h4
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        Payment Terms: Invoice to be settled by {dueDate}
                      </h4>
                    </div>
                  </div>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  {/* <div style={{ position: "fixed", bottom: 0 }}> */}
                  <hr
                    style={{
                      border: "1px solid Light gray",
                    }}
                  />
                  <div
                    className="col-md-12"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <h5>Company Number : 12345</h5>
                  </div>
                  <div
                    className="col-md-12"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <a href="https://www.wizmen.net/">
                      Generated by www.wizmen.net
                    </a>
                  </div>

                  <div className="col-md-2"></div>
                  {/* </div> */}
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Row className="app-body-Invoice">
            <Col>
              <div
                className="col-md-12"
                style={{ width: "1100px", margin: "0 auto" }}
              >
                <div className="col-md-9">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 style={{ fontWeight: "bold" }}>
                        Invalid Route {invoiceNo}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  }
}
export default PrintViewCN;
